import React, { createContext, useContext, useState } from "react";

const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [currentAssistant, setCurrentAssistant] = useState("confluence");
  const [chats, setChats] = useState({});
  const [selectedModel, setSelectedModel] = useState("claude3Sonnet"); // default model

  const value = {
    currentAssistant,
    setCurrentAssistant,
    chats,
    setChats,
    selectedModel,
    setSelectedModel
  };

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error("useChat must be used within a ChatProvider");
  }
  return context;
};